import { sharedStyles } from "@lib/sharedStyles";
import { CustomEventType } from "@/events/CustomEventRegistry";
import { LitElement, css, html } from "lit";
import { customElement } from "lit/decorators.js";

@customElement("empty-events-table-card")
export class EmptyEventsTableCard extends LitElement {
	static readonly styles = [
		sharedStyles,
		css`
		.empty-state {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 24px;
			gap: 16px;
		}
	`];

	private handleClick() {
		this.dispatchEvent(new CustomEvent(CustomEventType.CREATE_EVENT, { bubbles: true, composed: true }));
	}

	render() {
		return html`
			<div class="empty-state">
				<h2>Noch keine Events vorhanden</h2>
				<p>Erstellen Sie Ihr erstes Event, um loszulegen!</p>
				<basic-button @click=${this.handleClick}>
					Erstes Event erstellen
				</basic-button>
			</div>
		`;
	}
}

export default EmptyEventsTableCard;